import * as React from 'react';

const SmallLogo = () => <img src={require('./agora-logo-250px.gif')} alt="Agora IP"/>

export default SmallLogo;